import React from "react";

import {compact, isEmpty} from "@pg-mono/nodash";

type AnswerType = string | boolean;

interface ISchemaOfferDetailFAQ {
    transportAnswer?: AnswerType;
    transportQuestion: string;
    educationAnswer?: AnswerType;
    educationQuestion: string;
    servicesAnswer?: AnswerType;
    servicesQuestion: string;
}

const getFAQSchemaEntity = (question: string, answer?: AnswerType) => {
    if (answer) {
        return {
            "@type": "Question",
            name: question,
            acceptedAnswer: {
                "@type": "Answer",
                text: answer
            }
        };
    }
};

export const SchemaOfferDetailFAQ = (props: ISchemaOfferDetailFAQ) => {
    const {transportAnswer, transportQuestion, educationAnswer, educationQuestion, servicesAnswer, servicesQuestion} = props;

    const mainEntity = compact([
        getFAQSchemaEntity(transportQuestion, transportAnswer),
        getFAQSchemaEntity(educationQuestion, educationAnswer),
        getFAQSchemaEntity(servicesQuestion, servicesAnswer)
    ]);

    if (isEmpty(mainEntity)) {
        return null;
    }

    const json = {
        "@context": "https://schema.org/",
        "@type": "FAQPage",
        mainEntity
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import React from "react";

import {compact, isEmpty} from "@pg-mono/nodash";

type AnswerType = string | boolean;

interface ISchemaOfferDetailFAQ {
    transportAnswer?: AnswerType;
    transportQuestion: string;
    educationAnswer?: AnswerType;
    educationQuestion: string;
    servicesAnswer?: AnswerType;
    servicesQuestion: string;
}

const getFAQSchemaEntity = (question: string, answer?: AnswerType) => {
    if (answer) {
        return {
            "@type": "Question",
            name: question,
            acceptedAnswer: {
                "@type": "Answer",
                text: answer
            }
        };
    }
};

export const SchemaOfferDetailFAQ = (props: ISchemaOfferDetailFAQ) => {
    const {transportAnswer, transportQuestion, educationAnswer, educationQuestion, servicesAnswer, servicesQuestion} = props;

    const mainEntity = compact([
        getFAQSchemaEntity(transportQuestion, transportAnswer),
        getFAQSchemaEntity(educationQuestion, educationAnswer),
        getFAQSchemaEntity(servicesQuestion, servicesAnswer)
    ]);

    if (isEmpty(mainEntity)) {
        return null;
    }

    const json = {
        "@context": "https://schema.org/",
        "@type": "FAQPage",
        mainEntity
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
